module.exports = __webpack_public_path__ + "media/images/details__prizeBox__season__third-042245ace0b83f823672749aa857f341.png";